<template>
    <div class="main-header-container">
        <div class="header">
            <!-- Desktop and tablet header -->
            <div class="nav-container" data-not-narrow-mode>
                <div v-if="currentCustomer">
                    <span style="padding-left:1rem;">Hola </span><span class="bold">{{currentCustomer.firstName}}</span>
                </div>
                <div v-else>
                    <router-link to="/identificarse" class="router">
                        <span class="underline">Iniciar sesión</span> o <span class="underline">Registrarme</span>
                    </router-link>
                </div>
                <div class="container-item">
                    <div class="contact">
                        <span class="info-numbers pointer" @click="PhoneCall"><i class="fa fa-phone"></i>81 8353 2639</span>
                        <span class="info-numbers pointer" @click="OpenWhatsAppMessenger"><i class="fab fa-whatsapp"></i>811 764 0845</span>
                    </div>
                </div>
            </div>

            <!-- Mobile header view -->
            <div class="nav-container column" data-not-medium-mode data-not-wide-mode>
                <div v-if="currentCustomer" style="margin-top: 1em">
                    <span style="padding-left:1rem; font-size: 1.6em">Hola </span><span class="bold" style="font-size: 1.4em">{{currentCustomer.firstName}}</span>
                </div>
                <div v-else style="margin-top: 1em">
                    <router-link to="/identificarse" class="router">
                        <span class="underline">Iniciar sesión</span> o <span class="underline">Registrarme</span>
                    </router-link>
                </div>
                <div class="container-item">
                    <div class="contact">
                        <span class="info-numbers pointer" @click="PhoneCall"><i class="fa fa-phone"></i>81 8353 2639</span>
                        <span class="info-numbers pointer" @click="OpenWhatsAppMessenger"><i class="fab fa-whatsapp"></i>811 764 0845</span>
                    </div>
                </div>
            </div>

            <div class="grid-toolbar">
                <div class="toolbar gofarma-bg-blue row">
                    <div class="main-bar-buttons row">
                        <img class="pointer home-image" width="45%" src="https://images.gofarma.com.mx/gofarma_white.svg" @click="RouterPush('/')">

                        <!-- Desktop bar view -->
                        <div class="category-buttons row center" data-not-narrow-mode>
                            <div class="category-grid">
                                <i class="fa fa-2x fa-bars fa pointer" @click="ShowNarrowMenu()"/>
                            </div>
                            <div class="white gilroy">
                                Categorias
                            </div>
                        </div>
                    </div>
               
                    <div class="input-container">
                        <div class="div-input">
                            <form action="" @submit.prevent="SearchProduct">
                                <div class="round-search-bar">
                                    <input type="text" class="search-input" name="searchProduct" id="searchProduct" placeholder="Buscar producto">
                                    <button type="submit" class="search-button fa fa-search" ></button>
                                </div>
                            </form>
                        </div>
                    </div>
                  
                    <i class="fa fa-bars fa-2x pointer" style="margin-right: .5em" data-not-wide-mode data-not-medium-mode @click="ShowNarrowMenu()"/>
                    <i class="fa fa-shopping-cart fa-2x pointer" name="cartIcon" id="cartIcon" data-toggle-cart @click="ShowCart()"/>
                    <i v-if="currentCustomer" class="fas fa-user fa-2x popup" @click="OpenPoput()">
                       <span class="popuptext" id="myPopup">
                           <div class="poput-content"><span class="pointer" @click="OpenProfile(2)">Mis órdenes</span></div>
                           <div class="poput-content"><span class="pointer" @click="OpenProfile(1)">Editar mi perfil</span></div>
                           <div class="poput-content"><span class="pointer" @click="OpenProfile(3)">Mi botiquin</span></div>
                           <div class="poput-content"><span class="pointer" @click="OpenProfile(4)"> Mis direcciones</span></div>
                           <div class="poput-content"><span class="pointer" @click="OpenProfile(5)">Centro de ayuda</span></div>
                           <hr  class="poput-hr">
                           <div class="poput-content" @click="LogOut"><b>Cerrar sesión</b></div>
                       </span>
                    </i>
                </div>
            </div>
            <!-- poner en app-->
            <div id="NarrowMenu" class="narrow-menu" :class="{'active':narrowMenu}">
                <i class="fas fa-times fa-2x left-upper-corner" name="upperCornerIcon" id="upperCornerIcon" @click="ShowNarrowMenu()"/>
                <div class="categories-container pointer" v-for="(data,index) in categories" :key="index"
                     @click="ShowSubCategories(index)">{{data.name}}

                    <div v-if="SubCategoryIndex === index" :class="{'active-sub-categories':false}">
                        <div class="sub-categories pointer" v-for="(sub,index) in data.subcategories" :key="index"
                             @click="SearchByCategory(sub.slug)">{{sub.name}}
                        </div>
                        <!--<router-link to="/filtro">{{data.name}}</router-link> -->
                    </div>
                </div>
            </div>

            <!-- This is the cart overlay for whenever something is being added to the cart. -->
            <div class="overlay" :class="{'active':showCart}" @click="CloseCart($event)">
                <div class="columns" data-cart-loader>
                    <img src="https://images.gofarma.com/assets/images/loader.svg" alt="">
                </div>
                <Cart :class="{'active':showCart}"/>
            </div>

            <div class="search-bar-small-screen" data-not-wide-mode>
                <form action="" @submit.prevent="SearchProduct">
                    <input type="text" class="search-input" placeholder="Buscar producto" name="searchProduct" id="searchProduct">
                    <button type="submit" class="search-button fa fa-search"></button>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import Cart from './Cart'
import { mapState,mapActions } from 'vuex'
export default {
     name: 'Header',
     components: {
         Cart
     },
     methods:{
        ShowCart(){
            let showCart = !this.showCart
            this.$store.dispatch('SetAppScrollLock', showCart)
            this.$store.commit('StateAssign',{showCart})
        },
        CloseCart(e){
            if(!e.target.classList.contains('overlay')) return
            let showCart = !this.showCart
            this.$store.dispatch('SetAppScrollLock', showCart)
            this.$store.commit('StateAssign',{showCart})
        },
        ShowNarrowMenu(){
            let narrowMenu = !this.narrowMenu
            this.$store.commit('StateAssign',{narrowMenu})
        },
        ShowSubCategories(index){
            let SubCategoryIndex
            this.$store.state.SubCategoryIndex === index ? SubCategoryIndex = -1 : SubCategoryIndex = index
            this.$store.commit('StateAssign',{SubCategoryIndex})
        },
        OpenPoput() {
            if(this.currentCustomer){
                let popup = document.getElementById("myPopup")
                popup.classList.toggle("show")
            }
        },
        ...mapActions(['SearchProduct','RouterPush','PhoneCall','OpenWhatsAppMessenger', 'isUserAgent','LogOut','OpenProfile','SearchByCategory'])
     },
     computed:{
         ...mapState([
             'narrowMenu',
             'showCart',
             'categories',
             'ShowSubCategory',
             'SubCategoryIndex',
             'currentCustomer'
         ])
         /*narrowMenu:{
             get(){return this.$store.state.narrowMenu},
             set(value){return this.$store.state.narrowMenu = value}
         },
         showCart:{
             get(){return this.$store.state.showCart},
             set(value){return this.$store.state.showCart = value}
         }*/
     }
    }

</script>

<style scoped >
@import '../variables.css';
.category-grid{
    display: grid;
    padding-right: 0.625rem;
    margin-left: 0;
}
@-webkit-keyframes autofill {
    to {
        color: #fafafa;
        background: transparent;
    }
}
.search-button{
    background:transparent;
    border:none;
    outline:none;
}

.main-header-container{
    padding-bottom: 12rem;
}
.header{
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 99;
    background: #fafafa;
}
/* Popup container - can be anything you want */
.popup {
    position: relative;
    display: inline-block;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

/* The actual popup */
.popup .popuptext {
    visibility: hidden;
    width: auto;
    background-color: rgb(243, 243, 243);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 0;
    position: absolute;
    z-index: 1;
    top: 177%;
    left: 50%;
    margin-left: -90px;
}
.poput-content{
    font-size: 12px;
    padding:10px;
    text-align: left;
    font-family: Tahoma, Geneva, sans-serif;
    font-weight: 200;
}
.poput-hr{
    margin:0px 10px 0px;
}
.poput-content a{
    text-decoration: none;
    color: var(--dark-gofarma);
}
/* Popup arrow */
.popup .popuptext::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 83%;
    margin-left: -5px;
    border-width: 10px;
    border-style: solid;
    border-color: transparent transparent #fafafa transparent;
}

/* Toggle this class - hide and show the popup */
.popup .show {
    visibility: visible;
    -webkit-animation: fadeIn 1s;
    animation: fadeIn 1s;
}


/* Add animation (fade in the popup) */
@-webkit-keyframes fadeIn {
    from {opacity: 0;} 
    to {opacity: 1;}
}

@keyframes fadeIn {
    from {opacity: 0;}
    to {opacity:1 ;}
}
input:-webkit-autofill {
    -webkit-animation-name: autofill;
    -webkit-animation-fill-mode: both;
}
.main-bar-buttons{
    display: flex;
    align-items: center;
}
.input-container{
    display: flex; 
    width: 100%;
    justify-content: flex-end;
}
.search-input{
    border: 0px solid ;
    background: rgba(255, 255, 255, 0);
    height: 100%;
    width: 100%;
    padding: 0.625rem;
    box-sizing: border-box;
    color: #fafafa
}
.search-input:focus{
    outline: none;
}
.round-search-bar{
    width:100%;
    background-color: rgba(255, 255, 255, 0);
    position:relative;
}

.active-sub-categories{
    visibility: hidden;
    height: 0rem;
}
.sub-categories p {
    height: 0%;
    display: block;
    margin-block-start: 0em;
    margin-block-end: 0em;
    margin-inline-start: 0rem;
    margin-inline-end: 0rem;
}
.search-bar-small-screen{
    width:100%;
    background-color: #f8f8f8;
    position:relative;
    margin-top:0.625rem; 
}
.fa-home{
    padding-right:1rem;
}

.fa-bars{
    padding-left:0.625rem;
}
.fa-bars span{
    display:block;
    color:#fafafa;
    font: 25 0.83333125rem Arial;
}
.fa-search{
    position:absolute;right: 0.875rem;top: calc(50% - 0.4375rem);
}
.div-input{
    height: 2rem;
    width: 30%;
    float: left;
    margin-right: 2rem;
    background: transparent;
    border:0.035rem  solid rgba(70, 131, 224, 0.342);
    border-radius:1.25rem;
    color: #f5f5f5;
    text-align: center;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #f5f5f5;
  opacity: 1; /* Firefox */
}
.toolbar{
    align-items: center;
}

@media screen and (max-width: 26.25rem) {
    .cart {
        width: 100% !important;
        right: -100%;
    }

    .narrow-menu {
        width: 100% !important;
        left: -100%;
    }
}

@media (max-width: 60.0625rem){
    .main-header-container {
    padding-bottom: 1rem !important;
}
}

@media screen and (max-width:60.125rem){
    .div-input{
        visibility: hidden;
    }
    .search-input::placeholder{
        color:gray;
    }
    .search-input{
        color:gray;
    }
}

.media-logo{
    text-align: left;
    width: 45%;
}

@media screen and (min-width:60.125rem){
    .home-image{
        display: block;
    }
    .category-grid{
        margin-left:25px;
    }
    .media-logo{
        display: none;
    }
    .container-item{
        flex-direction: column;
    }
}

@media (max-width: 60.0625rem) {
    .header{
        position: static;
        top: 0;
        width: 100%;
        z-index: 99;
        background: #fafafa;
    }
    .main-header-container{
        padding-bottom: 18rem;
    }
}

@media screen and (min-width: 26.25000000000625rem) and (max-width: 64rem) {
    .cart {
        width: 60% !important;
        right: -60%;
    }

    .narrow-menu {
        width: 60% !important;
        left: -60%;
    }

    .home-image{
        width: 60%;
    }
}

@media(max-width: 41.5625rem){
    .home-image{
        width: 60%;
    }

    .row.start{
        justify-content: center !important;
    }
}


@media(max-width: 24.1875rem){
    .home-image{
        width: 80%;
    }

    .toolbar{
        padding: 0 1.175rem;
    }

    .search-bar{
        font-size: 0.75rem;
    }
}
</style>